import { fetchGql } from '../utils/fetch-gql';
import {
	startLoading,
	endLoading
} from './app-dux';
import { message } from 'antd';
import { DEFAULT_LOCALE_CODE } from '../constants';

/*******************************************************************************
 * Initial state
 */
const initialState = {
	defaultBundle: [],
	translationsBundle: [],
	updatedBundles: []
};

/*******************************************************************************
 * Non-async action types
 */
export const SET_KEY_BUNDLE = 'SET_KEY_BUNDLE';
export const CLEAR_SELECTED_KEY_BUNDLE = 'CLEAR_SELECTED_KEY_BUNDLE';
export const UPDATE_BUNDLE = 'UPDATE_BUNDLE';
export const UPDATE_DEFAULT_CUSTOM_BUNDLE = 'UPDATE_DEFAULT_CUSTOM_BUNDLE';
export const UPDATE_TRANSLATION_CUSTOM_BUNDLE = 'UPDATE_TRANSLATION_CUSTOM_BUNDLE';

/*******************************************************************************
 * Reducer
 */
export default function appReducer( state = initialState, action ) {

	switch ( action.type ) {
		case SET_KEY_BUNDLE:
			return {
				...state,
				defaultBundle: action.defaultBundle,
				translationsBundle: action.bundles
			};
		case UPDATE_DEFAULT_CUSTOM_BUNDLE:
			return {
				...state,
				defaultBundle: action.bundle
			};
		case UPDATE_TRANSLATION_CUSTOM_BUNDLE:
			return {
				...state,
				translationsBundle: action.bundle
			};
		case UPDATE_BUNDLE:
			const modifiedContent = [ ...state.updatedBundles ];
			const index = modifiedContent.findIndex( el => el.locale === action.bundle.locale );
			if ( index === -1 ) {
				modifiedContent.push( action.bundle );
			} else {
				modifiedContent[ index ] = action.bundle;
			}

			return {
				...state,
				updatedBundles: modifiedContent
			};
		case CLEAR_SELECTED_KEY_BUNDLE:
			return {
				...state,
				defaultBundle: [],
				translationsBundle: [],
				updatedBundles: []
			};
		default:
			return state;
	}
}

/*******************************************************************************
 * Action creators
 */

export const loadKey = ( projectName, keyName, locale = DEFAULT_LOCALE_CODE ) => async( dispatch, getState ) => {
	const gqlQuery = `query{
						keyBundle(projectName: "${ projectName }", keyName: "${ keyName }") {
							keyName
							bundles {
								locale
								goldCopy
								customCopy
							}
						}
					}`;

	// Clear previous key's data when loading a new key
	dispatch( clearSelectedKeyBundle() );
	
	dispatch( startLoading() );

	setTimeout( () => ( 'test' ), 5000 );
	try {
		const { data, errors } = await fetchGql( gqlQuery );

		if ( errors ) {
			throw new Error( errors );
		}

		const bundles = data.keyBundle.bundles;

		const defaultBundleIndex = bundles.findIndex( bundle => bundle.locale === locale );
		const defaultBundle = bundles[ defaultBundleIndex ];
		bundles.splice( defaultBundleIndex, 1 );

		dispatch( setKeyBundle( defaultBundle, bundles ) );
		return data.keyBundle;
	} finally {
		dispatch( endLoading() );
	}
};

export const updateCustomCopy = ( keyName, customCopy, selectedBundle ) => async( dispatch, getState ) => {
	let modifiedBundle = {};
	if ( selectedBundle.locale === DEFAULT_LOCALE_CODE ) {
		const { defaultBundle: bundle } = getState().editKey;
		// Create a new object instead of mutating the existing one
		modifiedBundle = {
			...bundle,
			customCopy
		};

		dispatch( updateDefaultCustomCopyBundle( modifiedBundle ) );
	}
	else {
		const updatedTranslationBundles = getState().editKey.translationsBundle.map( ( bundle ) => {
			if ( selectedBundle.locale === bundle.locale ) {
				const newBundle =  {
					...bundle,
					customCopy
				};
				modifiedBundle = newBundle;
				return newBundle;
			} else {
				return bundle;
			}
		} );

		dispatch( updateTranslationCustomCopyBundle( updatedTranslationBundles ) );
	}
	dispatch( updateBundle( modifiedBundle ) );
};

export const saveKey = ( projectName, keyName ) => async( dispatch, getState ) => {
	const { updatedBundles } = getState().editKey;

	const gqlQuery = `mutation saveKey($projectName: String!, $keyName: String!, $copyList: [Copy!]) {
		saveKey(projectName: $projectName, keyName: $keyName, copyList: $copyList) {
			success,
			errors {
                message,
                code
            }
		}
	}`;

	const variables = {
		projectName,
		keyName,
		copyList: updatedBundles
	};

	dispatch( startLoading() );

	try {
		const { data, errors } = await fetchGql( gqlQuery, variables );

		if ( errors ) {
			console.error( 'error', errors );
			message.error( `saving custom copy for key${ keyName } Failed.` );
		}

		if ( data.saveKey.success ) {
			message.success( `Successfully saved custom copy for key: ${ keyName }.` );
		} else {
			message.error( `saving custom copy for key${ keyName } Failed.` );
		}
		return data.saveKey.success;
	} finally {
		dispatch( endLoading() );
	}
};

export const updateBundle = bundle => ( { type: UPDATE_BUNDLE, bundle } );

export const updateDefaultCustomCopyBundle = bundle => ( { type: UPDATE_DEFAULT_CUSTOM_BUNDLE, bundle } );

export const updateTranslationCustomCopyBundle = bundle => ( { type: UPDATE_TRANSLATION_CUSTOM_BUNDLE, bundle } );

export const setKeyBundle = ( defaultBundle, bundles ) => ( { type: SET_KEY_BUNDLE, defaultBundle, bundles } );

export const clearSelectedKeyBundle = () => ( { type: CLEAR_SELECTED_KEY_BUNDLE } );